import { call } from "redux-saga/effects";
import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";
import { ReducerMethods } from "../../store/reducer.methods";
import { API_DOMENS, BASE_API_PAGE_ENUMS, BASE_API_PATHS } from "../../../constants/apis.constants";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import { CallToast } from "../../../Components/PriceCalculator/modals/CustomToast";
import type GetSecurityStackHeaderViewDto from "./dto/get-security-stack-header-view.dto";
import type UpdateSecurityStackHeaderViewDto from "./dto/update-security-stack-header-view.dto";

export const SecurityStackHeaderViewEffectActions = {
  getSecurityStackHeaderView: `${Entities.SecurityStackHeaderView}_getSecurityStackHeaderView`,
  updateSecurityStackHeaderView: `${Entities.SecurityStackHeaderView}_updateSecurityStackHeaderView`,
};

const initSchema: InitSchemaReducer = {
  definitions: {},
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.SecurityStackHeaderView,
  initSchema,
  aliasName: DIContainerKeys.SecurityStackHeaderViewService,
})
export class SecurityStackHeaderViewService extends HttpService {
  @loader(Loaders.GetSecurityStackHeaderViewLoader)
  @action(DIContainerKeys.SecurityStackHeaderViewService)
  public *getSecurityStackHeaderView(dto: GetSecurityStackHeaderViewDto): Generator<any, void, any> {
    yield this.setLoaderState(Loaders.GetSecurityStackHeaderViewLoader, true);
    const response = yield call(
      this.get,
      {
        url: this.pageEnum(BASE_API_PAGE_ENUMS.GetSecurityStackHeaderView)
      },
      ReducerMethods.UPDATE
    );
    if (!response?.mr?.Success) {
      CallToast("Something went wrong", false, false, "v2style");
      yield this.setLoaderState(Loaders.GetSecurityStackHeaderViewLoader, false);
      return;
    }
    yield this.setEntityState(Entities.SecurityStackHeaderView/*, dto.clientId*/, response);
    yield this.setLoaderState(Loaders.GetSecurityStackHeaderViewLoader, false);
  }

  @action(DIContainerKeys.SecurityStackHeaderViewService)
  public *updateSecurityStackHeaderView(dto: UpdateSecurityStackHeaderViewDto): any {
    const formData = this.toFormData(dto);
    const response = yield call(
      this.post,
      {
        url: BASE_API_PATHS.updateSecurityStackHeaderView,
        domain: API_DOMENS.CC_API,
        body: formData,
      },
      ReducerMethods.UPDATE
    );
    if (!response?.Success) {
      CallToast("Something went wrong", false, false, "v2style");
      yield this.setLoaderState(Loaders.GetUserDeviceIssuesLoader, false);
      return;
    } else {
      this.getSecurityStackHeaderView({ clientId: dto.SettingOwner })
    }
  }
}